import { api } from '../../app/api/baseApi';

export const loadBalancingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createLoadBalancingAutomation: builder.mutation<any, object>({
            query: (body) => ({
                url: `automation/v2/automations`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['LoadBalancingAutomations'],
        }),
        getLoadBalancingAutomationsWithFilter: builder.query<any, any>({
            query: (body) => ({
                url: `automation/v2/automations/filter`,
                method: 'POST',
                body,
            }),
            providesTags: ['LoadBalancingAutomations'],
        }),
        deleteLoadBalancingAutomations: builder.mutation<void, { automationBalancingIds: string[] }>({
            query: (body) => ({
                url: 'automation/v2/automations',
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['LoadBalancingAutomations'],
        }),
        updateLoadBalancingAutomationAccess: builder.mutation<void, { automationId: string; isEnabled: boolean }>({
            query: ({ automationId, isEnabled }) => ({
                url: `automation/v2/automations/${automationId}/access`,
                method: 'PATCH',
                body: { isEnabled },
            }),
            invalidatesTags: ['LoadBalancingAutomations'],
        }),
        updateLoadBalancingAutomation: builder.mutation<any, { automationId: string; payload: any }>({
            query: ({ automationId, payload }) => ({
                url: `automation/v2/automations/${automationId}`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['LoadBalancingAutomations'],
        }),
        getLoadBalancingAutomationById: builder.query<any, string>({
            query: (automationId) => ({
                url: `automation/v2/automations/${automationId}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'LoadBalancingAutomations', id }],
        }),
        getAutomationsByThreshold: builder.mutation<any, { deviceId: string; thresholdId: string }>({
            query: ({ deviceId, thresholdId }) => ({
                url: `automation/v2/automations/${deviceId}`,
                method: 'POST',
                body: { thresholdId },
            }),
        }),
        getAllActionByDeviceTypeId: builder.query<any, { params?: any; payload?: any }>({
            query: ({ params, payload }) => ({
                url: `ontology/v1/channels/actions`,
                method: 'POST',
                ...(params && { params: params }),
                body: payload,
            }),
        }),
        getAllEventByDeviceTypeId: builder.query<any, { params?: any; payload?: any }>({
            query: ({ params, payload }) => ({
                url: `ontology/v1/channels/events`,
                method: 'POST',
                ...(params && { params: params }),
                body: payload,
            }),
        }),
    }),
});

export const {
    useCreateLoadBalancingAutomationMutation,
    useGetLoadBalancingAutomationsWithFilterQuery,
    useDeleteLoadBalancingAutomationsMutation,
    useUpdateLoadBalancingAutomationAccessMutation,
    useUpdateLoadBalancingAutomationMutation,
    useGetLoadBalancingAutomationByIdQuery,
    useGetAutomationsByThresholdMutation,
    useGetAllActionByDeviceTypeIdQuery,
    useGetAllEventByDeviceTypeIdQuery,
} = loadBalancingApi;
